<template>
	<div class="text-center my-8">
		<h5 class="text-primary text-3xl font-semibold">
			{{ $t('service-area.cta.speeds.title') }}
		</h5>
		<p class="text-highlighted text-xl font-semibold py-3">
			{{ $t('service-area.cta.speeds.subtitle', { areaName }) }}
		</p>
		<div class="grid-cols-3 space-y-8 hidden md:grid">
			<ServiceAreasSpeedCard
				v-for="(option, index) in billableSpeeds"
				:key="option.speed"
				:option="option"
				:index="index"
			/>
		</div>
		<div class="max-w-screen -mx-4">
			<LazyUCarousel
				ref="service-areas-carousel"
				v-slot="{ item: option, index }"
				:autoplay="{ delay: 4000 }"
				:items="billableSpeeds"
				loop
				:ui="{
					item: 'basis-1/3 md:basis-1/4 group min-w-[250px]',
					container: 'py-6'
				}"
				arrows
				:prev="{ color: 'primary', variant: 'soft' }"
				:next="{ color: 'primary', variant: 'soft' }"
				:in-view-threshold="0.5"
				class-names
				wheel-gestures
				class="w-full sm:mask-linear-[90deg,transparent_5%,black,transparent_95%] md:hidden"
			>
				<ServiceAreasSpeedCard
					:key="option.speed"
					:option="option"
					:index="index"
					class="-ml-3"
				/>
			</LazyUCarousel>
		</div>
	</div>
</template>

<script setup lang="ts">
import { billableSpeeds } from '@/constants/components/speeds'

defineProps({
	areaName: {
		type: String,
		required: true
	}
})
</script>
